
<section [class.open]="display" class="fixed z-9999 inset-0 overflow-y-auto" >
  <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0 bg-gray-900/50 ">
    <div
      (click)="$event.preventDefault()"
      class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full "
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</section>
